import type { Job } from '@/api/types'

/**
 * The job list.
 *
 * Ported from `ADD_ITEM` in `web-frontend/modules/core/store/job.js`, which is
 * careful not to add the same job twice: a job started by this client arrives
 * once in the POST response and again over the websocket.
 */
export function addJob(jobs: Job[], job: Job): Job[] {
  if (jobs.some((existing) => existing.id === job.id)) return jobs
  return [...jobs, job]
}
